import { render, staticRenderFns } from "./SolarPanels.vue?vue&type=template&id=2f9c6fcd&"
import script from "./SolarPanels.vue?vue&type=script&lang=js&"
export * from "./SolarPanels.vue?vue&type=script&lang=js&"
import style0 from "./SolarPanels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports